import axios from 'axios'
import { getBackendUrl } from '@/general'

const BASE_URL = "/seguridad/api/";

export const getToken = async (user, psswrd) => {
  try {
    const { source } = await getBackendUrl();
    const data = {
      username: user,
      password: psswrd
    }

    const res = await axios.post(
      `${source}/api/getKey`,
      data
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const refreshToken = async (tokenRefresh) => {
  try {
    const { source } = await getBackendUrl();
    const data = {
      refresh: tokenRefresh
    }

    const res = await axios.post(
      `${source}/api/refreshKey`,
      data
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const updateSesionUsuario = async (context, uid, status) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const data = {
      Estado: status
    }
    const res = await axios.put(
      `${source}/seguridad/api/actualizaSesionUsuario/${uid}`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const validateSesionUsuario = async (context, uid) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/seguridad/api/validaSesionUsuario/${uid}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const requestClaveUsuario = async (user) => {
  try {
    const { source } = await getBackendUrl()
    await axios.get(
      `${source}/seguridad/api/solicitudClaveUsuario?usr=${user}`
    )
  } catch(err) {
    console.log(err);
    throw err
  }
}

export const validateClaveUsuario = async (key) => {
  try {
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/seguridad/api/validacionCambioClaveUsuario?K=${key}`
    )

    return res.data;
  } catch(err) {
    console.warn("Hola...", err);
    throw err
  }
}

export const assignNuevaClaveUsuario = async (token, idB64, newPassword) => {
  try {
    const { source } = await getBackendUrl();
    const data = {
        Token: token,
        Id_B64: idB64,
        Clave_Nueva: newPassword
    }
    const res = await axios.patch(
      `${source}/seguridad/api/cambioClaveUsuario`,
      data
    );

    return res.data;
  } catch(err) {
    console.warn(err);
    throw err
  }
}

export const changeClaveUsuario = async (context, oldPassword, newPassword) => {
  try {
    const { source } = await getBackendUrl();
    const data = {
      Clave_Anterior: oldPassword,
      Clave_Nueva: newPassword
    }
    const res = await axios.put(
      `${source}/archivo/api/cambioClaveUsuario`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const getDataUsuarioSession = async (context, token) => {
  try {
    const mtoken = context.$store.state.user.token ? context.$store.state.user.token : token
    // await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataUsuarioSession`,
      {
        headers: {
          'Authorization': `Bearer ${mtoken}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const saveAccesoUsuario = async (user, access) => {
  try {
    const { source } = await getBackendUrl()
    const body = {
      Usuario: user,
      Acceso: access
    }
    const res = await axios.post(
      `${source}/seguridad/api/grabaAccesoUsuario`,
      body
    );

    return res.data;
  } catch (err) {
    console.log(err.response)
    return err.response
  }
}

export const crudModuloAplicacion = async (state, typeAction, id, requestData) => {
  let response;
  const endpoint = "moduloAplicacion";

  try {
    // await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${endpoint}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${endpoint}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        console.log("Under construction...");
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${endpoint}/${id}`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "get": {
          const parameters = {
            "Modulo": requestData.modulo
          }
          response = await axios.get(
            `${source}${BASE_URL}${endpoint}/`,
            {
              params: parameters,
              headers: paramsHeader
            }
          );
          break;
        }
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err
  }
}

export const dataGridUsuarios = async (context, page, search, typeUser, idDirectory) => {
  try {
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let filterPath = typeUser === 'cliente' ? pagePath || searchPath ? `&idc=${idDirectory}` : `idc=${idDirectory}` : ''
    let path = pagePath || searchPath ? `?${pagePath}${searchPath}${filterPath}` : ''

    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/archivo/api/dataGridUsuarios/${typeUser}/${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const crudUsuario = async (context, typeAction, id, requestData) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    let response
    const endPoint = "/archivo/api/usuario"
    const { source } = await getBackendUrl()

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${endPoint}`,
          requestData,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )
        break
      case "read":
        console.log("Under construction...");
        break
      case "update":
        console.log("Under construction...");
        break
      case "delete":
        response = await axios.delete(
          `${source}${endPoint}/${id}`,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )    
        break
    }

    return response.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}
